// This module exists both to handle browsers that doesn't have `sessionStorage`
// and for private browsing in iOS which throws exceptions when you call `setItem`

const fauxStorage = {};

export function setSesstionStorage(key: string, value: any) {
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    fauxStorage[key] = value;
    console.error('sessionStorage.setItem() failed:', e);
  }
}

export function getSessionStorage<T>(key: string, defaultValue?: T) {
  try {
    const value = sessionStorage.getItem(key);
    if (value === null) {
      return defaultValue;
    } else {
      return JSON.parse(value) as T;
    }
  } catch (e) {
    console.error('sessionStorage.getItem() failed:', e);
    if (!(key in fauxStorage)) {
      return defaultValue;
    }
    return fauxStorage[key] as T;
  }
}
